import React from "react";
import Tooltip from "@lwt-helix/tooltip";
import PropTypes from "prop-types";

const CustomHeader = ({ headerDetails }) => {
    if(!headerDetails) return null;
    
    return <>
        <Tooltip
            target={headerDetails?.id}
            placement="top"
            boundariesElement="window"
            className={headerDetails?.isLastColumn ? 'last-header-tooltip' : ''}
        >
            <span className='helix-small'>{headerDetails?.tip}</span>
        </Tooltip>
        {<span id={headerDetails?.id} className='clickable'>
            {headerDetails?.label}
        </span>}
    </>;
};

CustomHeader.propTypes = {
    headerDetails: PropTypes.object,
};

export default CustomHeader;
